(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-cocada-form]');
    const panels = [...root.querySelectorAll('[data-cocada-coffin]')];
    const quantity = form.elements.quantity;
    const money = new Intl.NumberFormat(root.dataset.locale, {style:'currency', currency:root.dataset.currency});
    form.querySelector('button[type="submit"]').disabled = !(root.dataset.preview === 'true' || root.dataset.purchasable === 'true');
    const update = () => {
      let ready = 0;
      panels.forEach(panel => {
        const flavor = panel.querySelector('[data-cocada-flavor]:checked');
        panel.dataset.complete = flavor ? 'true' : 'false';
        panel.querySelector('[data-syrup-property]').value = flavor ? flavor.value : '';
        panel.querySelector('[data-cocada-status]').textContent = flavor ? flavor.closest('label').querySelector('span').textContent.trim() : root.dataset.choose;
        if (flavor) ready++;
      });
      root.querySelector('[data-cocada-progress]').textContent = ready + ' / 2 ' + root.dataset.ready;
      root.querySelector('[data-cocada-total]').textContent = money.format(Number(root.dataset.price) / 100 * Math.max(1,Number(quantity.value)||1));
    };
    form.addEventListener('change',update);
    form.addEventListener('input',update);
    form.addEventListener('invalid',event => {const panel = event.target.closest('[data-cocada-coffin]'); if (panel) panel.open = true;},true);
    form.addEventListener('submit',event => {
      update();
      if (root.dataset.preview === 'true') {
        event.preventDefault();
        const summary = root.querySelector('[data-cocada-preview-summary]');
        summary.textContent = root.dataset.previewDone + '\n\n' + panels.map(panel => panel.querySelector('summary strong').textContent.trim() + '\n' + panel.querySelector('[data-cocada-status]').textContent.trim()).join('\n\n');
        summary.hidden = false;
        summary.scrollIntoView({block:'center',behavior:'instant'});
      }
    });
    update();
  };
  const start = () => document.querySelectorAll('[data-halloween-cocadas]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();
